import React, { FC } from 'react';
import {
  ArrowSearchCont,
  DropSearchInput,
  ErrorIconCont,
  ErrorMessage,
  ErrorMsgCont,
  ErrorMsgIcon,
  InfoIconCont,
  InfoStaticMessage,
} from './SearchInputHeader.styles';
import ArrowIcon from '@/assets/icons/arrowRightIcon.svg?react';
import ErrorInputIcon from '@/assets/icons/errorInputIcon.svg?react';
import InfoIcon from '@/assets/icons/infogrey.svg?react';

interface ISearchInputHeader {
  active: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  setActive?: (value: boolean) => void;
  placeholder: string;
  error?: string;
  infoMessage?: string;
  searchForList?: (val: React.ChangeEvent<HTMLInputElement>) => void;
  noDrop?: boolean;
  defaultValue?: string;
  width?: string;
  height?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInputHeader: FC<ISearchInputHeader> = ({
  active,
  error,
  infoMessage,
  placeholder,
  searchForList,
  inputRef,
  setActive,
  noDrop,
  defaultValue = '',
  width,
  height = '48px',
  onChange,
}) => {
  return (
    <div>
      {!!error && (
        <ErrorIconCont>
          <ErrorInputIcon />
        </ErrorIconCont>
      )}
      <DropSearchInput
        width={width}
        height={height}
        data-testid="InputInInputHeader"
        ref={inputRef}
        placeholder={placeholder}
        onChange={e => {
          searchForList?.(e);
          onChange?.(e);
        }}
        error={!!error}
        defaultValue={defaultValue}
      />
      {!!infoMessage && !error && (
        <InfoIconCont>
          <InfoIcon />
          <InfoStaticMessage data-testid="infoBelowInputHeader">{infoMessage}</InfoStaticMessage>
        </InfoIconCont>
      )}
      {!!error && (
        <ErrorMsgCont data-testid="errorBelowInputHeader">
          <ErrorMsgIcon /> <ErrorMessage>{error}</ErrorMessage>
        </ErrorMsgCont>
      )}
      {!noDrop && (
        <ArrowSearchCont
          data-testid="dropArrowInSearchInput"
          active={active}
          onClick={() => setActive && setActive(!active)}
        >
          <ArrowIcon />
        </ArrowSearchCont>
      )}
    </div>
  );
};

export default SearchInputHeader;
